import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-gray-900 rounded-lg shadow-lg p-3 hover:shadow-xl transition-shadow duration-300" }
const _hoisted_2 = { class: "flex items-center space-x-2 mb-3" }
const _hoisted_3 = { class: "px-2 py-0.5 bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 text-xs rounded-full font-medium animate-pulse" }
const _hoisted_4 = { class: "space-y-1" }
const _hoisted_5 = ["onClick", "disabled"]
const _hoisted_6 = { class: "relative flex items-center justify-between p-2" }
const _hoisted_7 = { class: "flex items-center space-x-2" }
const _hoisted_8 = { class: "flex-shrink-0" }
const _hoisted_9 = {
  key: 0,
  class: "w-3 h-3 transform group-hover:scale-110 transition-transform",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_10 = {
  key: 1,
  class: "w-3 h-3 transform group-hover:scale-110 transition-transform",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_11 = {
  key: 2,
  class: "w-3 h-3 transform group-hover:scale-110 transition-transform",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_12 = { class: "flex-1 text-left" }
const _hoisted_13 = { class: "text-xs font-medium text-gray-900 dark:text-white group-hover:text-green-600 dark:group-hover:text-green-400 transition-colors" }
const _hoisted_14 = { class: "text-xs text-gray-500 dark:text-gray-400 flex items-center space-x-1" }
const _hoisted_15 = { class: "flex items-center space-x-2" }
const _hoisted_16 = { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }
const _hoisted_17 = { class: "flex-shrink-0" }
const _hoisted_18 = {
  key: 0,
  class: "w-4 h-4 text-gray-400 group-hover:text-green-500 transform group-hover:translate-y-0.5 group-hover:scale-110 transition-all duration-300",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_19 = {
  key: 1,
  class: "w-4 h-4 text-green-500 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_20 = {
  key: 0,
  class: "absolute bottom-0 left-0 h-0.5 bg-green-500 animate-pulse",
  style: {"width":"60%"}
}

import { ref } from 'vue';

interface Resolution {
  name: string
  dimensions: string
  size: string
  url: string
}

interface Props {
  resolutions: Resolution[]
  isDownloading: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadPanel',
  props: {
    resolutions: {},
    isDownloading: { type: Boolean }
  },
  emits: ["download", "create-account", "download-success", "download-error"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const emit = __emit;

const isDownloading = ref(false);
// Handle successful download
const handleDownloadSuccess = () => {
  // Emit the download success event to the parent
  emit('download-success');
};

const getQualityClass = (name: string): string => {
  if (name.includes('4K') || name.includes('2160')) {
    return 'bg-gradient-to-r from-purple-500 to-pink-500 text-white'
  } else if (name.includes('HD') || name.includes('1080')) {
    return 'bg-gradient-to-r from-blue-500 to-cyan-500 text-white'
  } else if (name.includes('Original')) {
    return 'bg-gradient-to-r from-green-500 to-emerald-500 text-white'
  }
  return 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300'
}

const downloadResolution = async (resolution: Resolution) => {
  if (isDownloading.value) return;
  
  isDownloading.value = true;
  try {
    emit('download', resolution);
    // The actual download will be handled by the parent component
    // which will emit a 'download-success' event when done
  } catch (error) {
    console.error('Download failed:', error);
  } finally {
    isDownloading.value = false;
  }
};

// Expose methods to parent component
__expose({
  isDownloading,
  handleDownloadSuccess
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"p-1.5 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg\" data-v-4ecb0047><svg class=\"w-4 h-4 text-white animate-bounce\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-4ecb0047><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10\" data-v-4ecb0047></path></svg></div><h4 class=\"text-xs font-semibold text-gray-900 dark:text-white\" data-v-4ecb0047>Downloads</h4><div class=\"flex-1\" data-v-4ecb0047></div>", 3)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.resolutions.length), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resolutions, (resolution, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: resolution.dimensions,
          onClick: ($event: any) => (downloadResolution(resolution)),
          disabled: isDownloading.value,
          class: _normalizeClass(["w-full group relative overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700 hover:border-green-400 dark:hover:border-green-500 transition-all duration-300 hover:shadow-md hover:scale-102 active:scale-98", { 'animate-pulse opacity-50': isDownloading.value }]),
          style: _normalizeStyle({ animationDelay: `${index * 50}ms` })
        }, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/10 dark:to-emerald-900/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" }, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass([
                'p-1.5 rounded-md transition-all duration-300',
                getQualityClass(resolution.name)
              ])
                }, [
                  (resolution.name.includes('4K') || resolution.name.includes('2160'))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _cache[1] || (_cache[1] = [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M3 4a1 1 0 011-1h12a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2v8h2V8h2v6h2V6H7V6z",
                          "clip-rule": "evenodd"
                        }, null, -1)
                      ])))
                    : (resolution.name.includes('HD') || resolution.name.includes('1080'))
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[2] || (_cache[2] = [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
                            "clip-rule": "evenodd"
                          }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[3] || (_cache[3] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"
                          }, null, -1)
                        ])))
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(resolution.name), 1),
                _createElementVNode("div", _hoisted_14, [
                  _cache[4] || (_cache[4] = _createElementVNode("svg", {
                    class: "w-3 h-3",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    })
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString(resolution.dimensions), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(resolution.size), 1),
              _createElementVNode("div", _hoisted_17, [
                (!isDownloading.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_18, _cache[5] || (_cache[5] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 14l-7 7m0 0l-7-7m7 7V3"
                      }, null, -1)
                    ])))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_19, _cache[6] || (_cache[6] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }, null, -1)
                    ])))
              ])
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "absolute inset-0 -translate-x-full group-hover:translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-700 ease-out" }, null, -1)),
          (isDownloading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20))
            : _createCommentVNode("", true)
        ], 14, _hoisted_5))
      }), 128))
    ]),
    _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"mt-3 pt-2 border-t border-gray-200 dark:border-gray-700\" data-v-4ecb0047><div class=\"flex items-center justify-between text-xs text-gray-500 dark:text-gray-400\" data-v-4ecb0047><div class=\"flex items-center space-x-1\" data-v-4ecb0047><svg class=\"w-3 h-3\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-4ecb0047><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M13 10V3L4 14h7v7l9-11h-7z\" data-v-4ecb0047></path></svg><span data-v-4ecb0047>Fast download</span></div><div class=\"flex items-center space-x-1\" data-v-4ecb0047><svg class=\"w-3 h-3\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-4ecb0047><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z\" data-v-4ecb0047></path></svg><span data-v-4ecb0047>High quality</span></div></div></div>", 1))
  ]))
}
}

})